export function getSearchApi() {
  return {
    endpoint: 'https://suggestqueries.google.com/complete/search',
    params: [
      {
        key: 'client',
        value: 'youtube',
      },
    ],
  };
}

export function getSearchKeywordSuggestionApi() {
  return {
    endpoint: __PROD__
      ? `https://timesofindia.indiatimes.com/auto_suggest_search_api.cms`
      : `https://toidev.indiatimes.com/auto_suggest_search_api.cms`,
    params: [
      {
        key: 'feedtype',
        value: 'sjson',
      },
      {
        key: 'hostid',
        value: '83',
      },
    ],
  };
}
export default { getSearchApi, getSearchKeywordSuggestionApi };
